import NextImage from 'next/image';

import NextLink from 'shared/components/NextLink';
import useTranslation from 'shared/hooks/useTranslation';

import { Typography } from '@/ui/shared/molecules/Typography/Typography';

import styles from './LinkInExpandedMenu.module.scss';
import * as types from './LinkInExpandedMenu.type';

export function LinkInExpandedMenu({ item }: types.LinkInExpandedMenu) {
  const { t } = useTranslation('common');

  return (
    <li className={styles.wrapper} key={item.id}>
      <NextLink aTag={item?.aTag} href={item.link} passHref>
        {item.icon ? (
          <div>
            <NextImage
              className={`${styles.icon} ${item.icon === 'gmb-masters' ? styles['icon--default'] : ''}`}
              src={`/img/temporary-menu-icons/${item.icon}.svg`}
              alt={item.name}
              width={24}
              height={24}
            />
          </div>
        ) : null}
        <div>
          <Typography.Header size="xs" tagType="div" gutterBottom={false}>
            {item.name.includes('.') ? t(`navbar.${item.name}`) : item.name}
          </Typography.Header>
          {item.injectHtml ? (
            <Typography.Paragraph size="xs" tagType="div" gutterBottom={false}>
              <div dangerouslySetInnerHTML={{ __html: item.description }} />
            </Typography.Paragraph>
          ) : (
            <Typography.Paragraph size="xs" tagType="div" gutterBottom={false}>
              {t(`navbar.${item.description}`)}
            </Typography.Paragraph>
          )}
        </div>
      </NextLink>
    </li>
  );
}
